import { useStrings } from "@1js/localization-components";
import {
  Body1,
  Image,
  makeStyles,
  Subtitle1,
} from "@fluentui/react-components";
import React from "react";
import { NoResultV2Heading, NoResultV2SubHeading } from "./NoResultsV2.strings";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    minHeight: "370px",
    padding: "60px 40px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "24px",
    flexShrink: 0,
    alignSelf: "stretch",
  },
});

export const NoResultsV2 = () => {
  const styles = useStyles();
  const localizations = useStrings({
    NoResultV2Heading,
    NoResultV2SubHeading,
  });

  return (
    <div className={styles.root}>
      <Image
        src="https://copilot.cloud.microsoft/images/0175-search-questionmark-d-standard-128x128.webp"
        aria-labelledby="no-results-filter-heading"
      />
      <Subtitle1 id="no-results-filter-heading">
        {localizations.NoResultV2Heading()}
      </Subtitle1>
      <Body1>{localizations.NoResultV2SubHeading()}</Body1>
    </div>
  );
};
